export default "__VITE_ASSET__DQs5YYtX__"